/* eslint-disable react/no-danger */

import PropTypes from 'prop-types'
import { Toast } from 'react-bootstrap'

const Text = ({ text }) => (
  <Toast.Header>
    <strong
      className='toast-text mr-auto'
      dangerouslySetInnerHTML={{ __html: text }}
    />
  </Toast.Header>
)

export default Text

Text.propTypes = { text: PropTypes.string.isRequired }
